/**
 * @file
 * Placeholder file for custom sub-theme behaviors.
 *
 */
(function($, Drupal, drupalSettings) {

  /**
   * @type {{attach: Drupal.behaviors.globalBehaviour.attach}}
   */
  Drupal.behaviors.globalBehaviour = {
    attach : function(context, settings) {
      $('#block-dropdown-language, #block-dropdown-language .language-link').click(function() {
        window.pppMenuPopIn.closePopIn('#block-dropdown-language');
      });

      // Search block mobile behaviour
      $("#mobile-search-btn").click(function() {
        var searchBlock = $('.search-block-wrapper');
        var closeSvg = $('.close-search-svg');
        var openSvg = $('.open-search-svg');

        searchBlock.toggleClass("closed");
        closeSvg.toggleClass("hidden");
        openSvg.toggleClass("hidden");
        searchBlock.attr("aria-hidden", searchBlock.hasClass('closed'));
        if (!searchBlock.hasClass('closed')) {
          setTimeout(function() {
            $('.block-pppsearchblock .form-text').focus();
          }, 200);
        }
      });

      // meta-header hide when page scrolled
      window.onscroll = function() {
        var speed = 200;
        if (window.pageYOffset > 0) {
          $(".meta-header").fadeOut(speed);
          $(".link--blog").fadeOut(speed);
        } else {
          $(".meta-header").fadeIn(speed);
          $(".link--blog").fadeIn(speed);
        }
      }

      // Manage cookies pop-in
      $(context).find("a[href$='#cookie']").click(function(e) {
        window.pppMenuPopIn.togglePopIn('#tartealamyrtille', '#tartealamyrtille-button-wrapper',
          '#first-focus-tartealamyrtille');
      });

      // Keep "nous contacter" form open after submit ---
      let $nousContacterForm = $(".node--type--tc17-faq .webform-wrapper");
      let $qAndAWrapper = $(".q-and-a--wrapper");
      let searchParams = new URLSearchParams(window.location.search);
      if (searchParams.get('formContact') === "open") {
        setInterval(unHideNousContacter, 300); // interval to let other scripts to finish
      }

      function unHideNousContacter() {
        $nousContacterForm.removeClass("hidden");
        $qAndAWrapper.hide();
      }

      // ---

      // Disable all options underneath "me désabonner complètement"'s checkbox
      $("#edit-unsubscribe-to-all").change(function(e) {
        let isUnsubscribeToAllChecked = $(e.target).is(':checked');
        if ($('#edit-subscribe-to-news')) {
          $('#edit-subscribe-to-news').prop("disabled", isUnsubscribeToAllChecked);
        }
        if ($('.area-checkbox')) {
          $('.area-checkbox').prop("disabled", isUnsubscribeToAllChecked);
        }
        if ($('.child-checkbox')) {
          $('.child-checkbox').prop("disabled", isUnsubscribeToAllChecked);
        }
        if ($('#edit-subscribe-to-newsletter')) {
          $('#edit-subscribe-to-newsletter').prop("disabled", isUnsubscribeToAllChecked);
        }

      });

      // Captcha
      $(context).find('.captcha .image-captcha > div > button').click();

      // Focusable  quick-access-card
      $(context).find('.quick-access-card *')
        .on('focus', function(evt) {
          $(evt.currentTarget).parents('.quick-access-card--front').addClass('focused')
        })
        .on('focusout', function(evt) {
          $(evt.currentTarget).parents('.quick-access-card--front').removeClass('focused')
        })

      // #PPSITE2018_RQM-662 - Gestion des tables et scroll horizontal
      context.querySelectorAll('table').forEach(function(table) {
        if( table.parentElement.childElementCount === 1 ){
          table.parentElement.classList.add('table-wrapper')
        }
        else{
          var outerHTML = table.outerHTML;
          outerHTML = '<div class="table-wrapper">' + outerHTML +'</div>'
          table.outerHTML = outerHTML;
        }
      })
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.carouselBehaviour.attach}}
   */
  Drupal.behaviors.carouselBehaviour = {
    attach : function(context, settings) {

      var defaultSlickOption = {
        centerMode : true,
        centerPadding : '200px',
        slidesToShow : 3,
        slidesToScroll : 3,
        variableWidth : true,
        dots : true,
        arrow : false,
        prevArrow : $('.slick-custom-prev'),
        nextArrow : $('.slick-custom-next'),
        responsive : [
          {
            breakpoint : 768,
            settings : {
              arrows : false,
              centerMode : true,
              centerPadding : '40px',
              slidesToShow : 3,
              slidesToScroll : 3
            }
          },
          {
            breakpoint : 480,
            settings : {
              arrows : false,
              centerMode : true,
              centerPadding : '40px',
              slidesToShow : 1,
              slidesToScroll : 1
            }
          }
        ]
      };

      var sliderSlickOption = {
        accessibility : 1,
        slidesToShow : 1,
        slidesToScroll : 1,
        variableWidth : false,
        dots : false,
        arrow : false,
        prevArrow : $('.slick-custom-prev'),
        nextArrow : $('.slick-custom-next'),
      };

      // Home page news caroussel
      $('.home-carousel').not('.slick-initialized').slick(defaultSlickOption);

      // Slider paragraph carousel
      $('.news-carousel').not('.slick-initialized').slick(sliderSlickOption);

      $('.button-back').click(function() {
        history.back();
      });
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.filterBlock.attach}}
   */
  Drupal.behaviors.filterBlock = {
    attach : function(context, settings) {
      var recruitmentBlock = $('.recruitment-block');

      function updateAriaRecruitmentBlock() {
        var recruitmentBlock = $('.recruitment-block');
        if (recruitmentBlock.hasClass('displayed')) {
          recruitmentBlock.attr("tabindex", "0");
          recruitmentBlock.attr("aria-hidden", "false");
        } else {
          recruitmentBlock.attr("tabindex", "-1");
          recruitmentBlock.attr("aria-hidden", "true");
        }

      }

      $(".display-block").click(function(e) {
        var target = $(e.target);
        if (target.data('block') !== "") {
          recruitmentBlock.removeClass("displayed");
          $("#" + target.data('block')).addClass("displayed");
        }
        updateAriaRecruitmentBlock();
      });
      $("#display-archive").click(function() {
        recruitmentBlock.removeClass("displayed");
        $("#block-archive").show();
        $("#filters-contests-recruitment").hide();
        $("#hide-archive").addClass("displayed").removeClass("hidden");
        $("#display-archive").addClass("hidden").removeClass("displayed");
        updateAriaRecruitmentBlock();
      });

      $("#hide-archive").click(function() {
        recruitmentBlock.removeClass("displayed");
        $("#block-all").addClass("displayed");
        $("#block-archive").hide();
        $("#filters-contests-recruitment").show();
        $("#hide-archive").addClass("hidden").removeClass("displayed");
        $("#display-archive").addClass("displayed").removeClass("hidden");
        $("#display-all").prop("checked", "true");
        updateAriaRecruitmentBlock();
      });
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.filterBlock.attach}}
   */
  Drupal.behaviors.masonry = {
    attach : function(context, settings) {
      var masonryContainer = $('.masonry-container');
      masonryContainer.masonry({"itemSelector" : ".masonry-item"});
      masonryContainer.imagesLoaded().progress(function() {
        masonryContainer.masonry('layout');
      });
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.filterBlock.attach}}
   */
  Drupal.behaviors.breadcrumbs = {
    attach : function(context, settings) {
      function isValidHttpUrl(string) {
        let url;
        try {
          url = new URL(string);
        } catch (_) {
          return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
      }

      if (!drupalSettings.pppJs || !drupalSettings.pppJs.isFullDisplay) {
        $('.full-display-buttons').addClass('hidden');
      }
      $('.facebook-share.share, .twitter-share.share').click(function(e) {
        e.preventDefault();
        var link = this.href.replace('&#039;', '\'').replace('&quot;', '"');
        if (isValidHttpUrl(link)) {
          window.open(link, '_blank', 'width=400, height=300');
        } else {
          console.error("Invalid url in breadcrumb");
        }
      });
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.filterBlock.attach}}
   */
  Drupal.behaviors.lineClamp = {
    attach : function(context, settings) {
      window.pppUpdatelineClamp = function(target) {
        target = target || '.line-clamp';
        window.shave($, target);
      };
      window.pppUpdatelineClamp();

      window.updatelineClampTimeout = undefined;

      window.addEventListener('resize', function() {
        if (window.updateLineClampTimeout) {
          clearTimeout(window.updateLineClampTimeout);
        }
        window.updateLineClampTimeout = setTimeout(window.pppUpdatelineClamp, 600);
      }, true);
    }
  };

  /**
   * @type {{attach: Drupal.behaviors.filterBlock.attach}}
   */
  Drupal.behaviors.childCheckboxes = {
    attach : function(context, settings) {
      $('.checkbox-accordion, .child-checkbox').change(function(e) {
        var target = $(e.target);
        var name = target.attr("data-name");
        var parent = $("#" + target.data("parent"));
        var child = $('.child-checkbox.' + name);
        child.prop('checked', target.is(":checked"));
        child.addClass('data-ignored');

        if (target.is(":checked") === false && parent !== undefined) {
          parent.prop('checked', false);
          child.removeClass('data-ignored');
          var greatFather = parent.data("parent");
          if (greatFather !== undefined) {
            $("#" + greatFather).prop('checked', false);
          }
        }
      });

      // Manage "-" and "+" on accordions with children accordions
      $(".subscriber-form-accordion li.accordion-item").click(function() {
        $(".subscriber-form-accordion li.accordion-item:not('.is-active') > a.accordion-title")
          .addClass("accordion-before-plus");
        $(".subscriber-form-accordion li.accordion-item.is-active > a.accordion-title")
          .removeClass("accordion-before-plus");
      });

      $('#edit-subscribe-form-submit').click(function(event) {
        event.preventDefault();
        var form = $("#ppp-subscribe-form");
        form.find(".data-ignored").prop('disabled', true);
        form.submit();
      });
    }
  };
})(jQuery, Drupal, drupalSettings);
